import Layout from "@components/Layout";
import RadioInputButton from "@components/RadioInputButton";
import { useTranslation } from "react-i18next";
import { Form, useSubmit } from "react-router-dom";

export default function YouTubeOrPodcastsPage() {
  const submit = useSubmit();
  const { t } = useTranslation();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form);
  };

  return (
    <Layout>
      <div className="flex h-full flex-col">
        <div className="shrink-0">
          <h1 className="heading">
            {t("pages.onboarding.youTubeOrPodcasts.heading")}
          </h1>
        </div>

        <Form
          className="flex grow flex-col justify-center space-y-5"
          method="post"
        >
          <RadioInputButton
            className=""
            label={t("pages.onboarding.youTubeOrPodcasts.regularly")}
            name="youtube-or-podcasts"
            onChange={handleChange}
            value="regularly"
          />

          <RadioInputButton
            className=""
            label={t("pages.onboarding.youTubeOrPodcasts.occasionally")}
            name="youtube-or-podcasts"
            onChange={handleChange}
            value="occasionally"
          />

          <RadioInputButton
            className=""
            label={t("pages.onboarding.youTubeOrPodcasts.rarely")}
            name="youtube-or-podcasts"
            onChange={handleChange}
            value="rarely"
          />

          <RadioInputButton
            className=""
            label={t("pages.onboarding.youTubeOrPodcasts.no")}
            name="youtube-or-podcasts"
            onChange={handleChange}
            value="no"
          />
        </Form>
      </div>
    </Layout>
  );
}
